export default {
  initial: {
    query: '',
    total_account_balance: undefined,
  },
  configuration: {
    query: {
      order: 1,
      subbutton: { isVisible: (value = '') => !!value },
      label: 'recommendations::type.filters.query.label',
      placeholder: 'recommendations::type.filters.query.placeholder',
      type: 'input',
    },
    total_account_balance: {
      order: 1,
      subbutton: { isVisible: (value = '') => !!value },
      label: 'recommendations::type.filters.total_account_balance.label',
      type: 'select',
      renderEmptyOptionAsOption: true,
      emptyOptionLabel:
        'recommendations::type.filters.total_account_balance.empty_option_label',
      optionLabelPrefix:
        'recommendations::type.filters.total_account_balance.options.',
      options: ['gt50', 'lte50', 'lte10', 'empty', 'no_limit'],
    },
  },
}
